"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MsgDeleteExternalTokenResponse = exports.MsgDeleteExternalToken = exports.MsgUpdateExternalTokenResponse = exports.MsgUpdateExternalToken = exports.MsgWithdrawTokenResponse = exports.MsgWithdrawToken = exports.MsgRegisterDeployedTokenResponse = exports.MsgRegisterDeployedToken = exports.MsgDeployNativeTokenResponse = exports.MsgDeployNativeToken = exports.MsgDeregisterExternalTokenResponse = exports.MsgDeregisterExternalToken = exports.MsgRegisterExternalTokenResponse = exports.MsgRegisterExternalToken = exports.MsgRemoveNonceMapForConnectionResponse = exports.MsgRemoveNonceMapForConnection = exports.MsgRemoveControllersForConnectionResponse = exports.MsgRemoveControllersForConnection = exports.MsgUpdateControllersForConnectionResponse = exports.MsgUpdateControllersForConnection = exports.MsgAddControllersForConnectionResponse = exports.MsgAddControllersForConnection = exports.MsgRemoveConnectionResponse = exports.MsgRemoveConnection = exports.MsgUpdateConnectionResponse = exports.UpdateConnectionParams = exports.MsgUpdateConnection = exports.MsgCreateConnectionResponse = exports.MsgCreateConnection = exports.MsgAxelarCallContractWithTokenResponse = exports.MsgAxelarCallContractWithToken = exports.MsgAxelarCallContractResponse = exports.MsgAxelarCallContract = exports.MsgAxelarSendTokenResponse = exports.MsgAxelarSendToken = exports.MsgUpdateParamsResponse = exports.MsgUpdateParams = exports.MsgUpdateRefundAddressResponse = exports.MsgUpdateRefundAddress = exports.MsgUpdateRelayWhitelistDurationResponse = exports.MsgUpdateRelayWhitelistDuration = exports.MsgUpdateMaxRelayExpiryResponse = exports.MsgUpdateMaxRelayExpiry = exports.MsgUpdateIbcTimeoutHeightOffsetResponse = exports.MsgUpdateIbcTimeoutHeightOffset = exports.MsgUpdateAxelarIbcChannelResponse = exports.MsgUpdateAxelarIbcChannel = exports.MsgSetBridgeEnabledResponse = exports.MsgSetBridgeEnabled = exports.protobufPackage = void 0;
exports.MsgClientImpl = exports.MsgRemoveRelayerResponse = exports.MsgRemoveRelayer = exports.MsgAddRelayerResponse = exports.MsgAddRelayer = exports.MsgConfirmPendingActionResponse = exports.MsgConfirmPendingAction = exports.MsgRevertPendingActionResponse = exports.MsgRevertPendingAction = exports.MsgPruneExpiredPendingActionsResponse = exports.MsgPruneExpiredPendingActions = exports.MsgStartRelayResponse = exports.MsgStartRelay = exports.MsgExecuteFromCarbonResponse = exports.MsgExecuteFromCarbon = void 0;
/* eslint-disable */
const long_1 = __importDefault(require("long"));
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const duration_1 = require("../../../google/protobuf/duration");
const params_1 = require("./params");
const coin_1 = require("../../../cosmos/base/v1beta1/coin");
const bridge_1 = require("./bridge");
const wrappers_1 = require("../../../google/protobuf/wrappers");
exports.protobufPackage = "Switcheo.carbon.bridge";
const baseMsgSetBridgeEnabled = {
    creator: "",
    bridgeId: long_1.default.UZERO,
    isEnabled: false,
};
exports.MsgSetBridgeEnabled = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (!message.bridgeId.isZero()) {
            writer.uint32(16).uint64(message.bridgeId);
        }
        if (message.isEnabled === true) {
            writer.uint32(24).bool(message.isEnabled);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgSetBridgeEnabled);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.bridgeId = reader.uint64();
                    break;
                case 3:
                    message.isEnabled = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgSetBridgeEnabled);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.bridgeId =
            object.bridgeId !== undefined && object.bridgeId !== null
                ? long_1.default.fromString(object.bridgeId)
                : long_1.default.UZERO;
        message.isEnabled =
            object.isEnabled !== undefined && object.isEnabled !== null
                ? Boolean(object.isEnabled)
                : false;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.bridgeId !== undefined &&
            (obj.bridgeId = (message.bridgeId || long_1.default.UZERO).toString());
        message.isEnabled !== undefined && (obj.isEnabled = message.isEnabled);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseMsgSetBridgeEnabled);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.bridgeId =
            object.bridgeId !== undefined && object.bridgeId !== null
                ? long_1.default.fromValue(object.bridgeId)
                : long_1.default.UZERO;
        message.isEnabled = (_b = object.isEnabled) !== null && _b !== void 0 ? _b : false;
        return message;
    },
};
const baseMsgSetBridgeEnabledResponse = {};
exports.MsgSetBridgeEnabledResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgSetBridgeEnabledResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgSetBridgeEnabledResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgSetBridgeEnabledResponse);
        return message;
    },
};
const baseMsgUpdateAxelarIbcChannel = { creator: "", channelId: "" };
exports.MsgUpdateAxelarIbcChannel = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.channelId !== "") {
            writer.uint32(18).string(message.channelId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgUpdateAxelarIbcChannel);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgUpdateAxelarIbcChannel);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.channelId =
            object.channelId !== undefined && object.channelId !== null
                ? String(object.channelId)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseMsgUpdateAxelarIbcChannel);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.channelId = (_b = object.channelId) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
const baseMsgUpdateAxelarIbcChannelResponse = {};
exports.MsgUpdateAxelarIbcChannelResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgUpdateAxelarIbcChannelResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgUpdateAxelarIbcChannelResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgUpdateAxelarIbcChannelResponse);
        return message;
    },
};
const baseMsgUpdateIbcTimeoutHeightOffset = {
    creator: "",
    offset: long_1.default.UZERO,
};
exports.MsgUpdateIbcTimeoutHeightOffset = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (!message.offset.isZero()) {
            writer.uint32(16).uint64(message.offset);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgUpdateIbcTimeoutHeightOffset);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.offset = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgUpdateIbcTimeoutHeightOffset);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.offset =
            object.offset !== undefined && object.offset !== null
                ? long_1.default.fromString(object.offset)
                : long_1.default.UZERO;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.offset !== undefined &&
            (obj.offset = (message.offset || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseMsgUpdateIbcTimeoutHeightOffset);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.offset =
            object.offset !== undefined && object.offset !== null
                ? long_1.default.fromValue(object.offset)
                : long_1.default.UZERO;
        return message;
    },
};
const baseMsgUpdateIbcTimeoutHeightOffsetResponse = {};
exports.MsgUpdateIbcTimeoutHeightOffsetResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgUpdateIbcTimeoutHeightOffsetResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgUpdateIbcTimeoutHeightOffsetResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgUpdateIbcTimeoutHeightOffsetResponse);
        return message;
    },
};
const baseMsgUpdateMaxRelayExpiry = { creator: "" };
exports.MsgUpdateMaxRelayExpiry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.expiry !== undefined) {
            duration_1.Duration.encode(message.expiry, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgUpdateMaxRelayExpiry);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.expiry = duration_1.Duration.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgUpdateMaxRelayExpiry);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.expiry =
            object.expiry !== undefined && object.expiry !== null
                ? duration_1.Duration.fromJSON(object.expiry)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.expiry !== undefined &&
            (obj.expiry = message.expiry
                ? duration_1.Duration.toJSON(message.expiry)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseMsgUpdateMaxRelayExpiry);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.expiry =
            object.expiry !== undefined && object.expiry !== null
                ? duration_1.Duration.fromPartial(object.expiry)
                : undefined;
        return message;
    },
};
const baseMsgUpdateMaxRelayExpiryResponse = {};
exports.MsgUpdateMaxRelayExpiryResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgUpdateMaxRelayExpiryResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgUpdateMaxRelayExpiryResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgUpdateMaxRelayExpiryResponse);
        return message;
    },
};
const baseMsgUpdateRelayWhitelistDuration = { creator: "" };
exports.MsgUpdateRelayWhitelistDuration = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.whitelistDuration !== undefined) {
            duration_1.Duration.encode(message.whitelistDuration, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgUpdateRelayWhitelistDuration);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.whitelistDuration = duration_1.Duration.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgUpdateRelayWhitelistDuration);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.whitelistDuration =
            object.whitelistDuration !== undefined &&
                object.whitelistDuration !== null
                ? duration_1.Duration.fromJSON(object.whitelistDuration)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.whitelistDuration !== undefined &&
            (obj.whitelistDuration = message.whitelistDuration
                ? duration_1.Duration.toJSON(message.whitelistDuration)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseMsgUpdateRelayWhitelistDuration);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.whitelistDuration =
            object.whitelistDuration !== undefined &&
                object.whitelistDuration !== null
                ? duration_1.Duration.fromPartial(object.whitelistDuration)
                : undefined;
        return message;
    },
};
const baseMsgUpdateRelayWhitelistDurationResponse = {};
exports.MsgUpdateRelayWhitelistDurationResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgUpdateRelayWhitelistDurationResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgUpdateRelayWhitelistDurationResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgUpdateRelayWhitelistDurationResponse);
        return message;
    },
};
const baseMsgUpdateRefundAddress = { creator: "", refundAddress: "" };
exports.MsgUpdateRefundAddress = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.refundAddress !== "") {
            writer.uint32(18).string(message.refundAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgUpdateRefundAddress);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.refundAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgUpdateRefundAddress);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.refundAddress =
            object.refundAddress !== undefined && object.refundAddress !== null
                ? String(object.refundAddress)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.refundAddress !== undefined &&
            (obj.refundAddress = message.refundAddress);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseMsgUpdateRefundAddress);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.refundAddress = (_b = object.refundAddress) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
const baseMsgUpdateRefundAddressResponse = {};
exports.MsgUpdateRefundAddressResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgUpdateRefundAddressResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgUpdateRefundAddressResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgUpdateRefundAddressResponse);
        return message;
    },
};
const baseMsgUpdateParams = { authority: "" };
exports.MsgUpdateParams = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.authority !== "") {
            writer.uint32(10).string(message.authority);
        }
        if (message.params !== undefined) {
            params_1.Params.encode(message.params, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgUpdateParams);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.authority = reader.string();
                    break;
                case 2:
                    message.params = params_1.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgUpdateParams);
        message.authority =
            object.authority !== undefined && object.authority !== null
                ? String(object.authority)
                : "";
        message.params =
            object.params !== undefined && object.params !== null
                ? params_1.Params.fromJSON(object.params)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.authority !== undefined && (obj.authority = message.authority);
        message.params !== undefined &&
            (obj.params = message.params ? params_1.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseMsgUpdateParams);
        message.authority = (_a = object.authority) !== null && _a !== void 0 ? _a : "";
        message.params =
            object.params !== undefined && object.params !== null
                ? params_1.Params.fromPartial(object.params)
                : undefined;
        return message;
    },
};
const baseMsgUpdateParamsResponse = {};
exports.MsgUpdateParamsResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgUpdateParamsResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgUpdateParamsResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgUpdateParamsResponse);
        return message;
    },
};
const baseMsgAxelarSendToken = {
    creator: "",
    destinationChain: "",
    destinationAddress: "",
};
exports.MsgAxelarSendToken = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.destinationChain !== "") {
            writer.uint32(18).string(message.destinationChain);
        }
        if (message.destinationAddress !== "") {
            writer.uint32(26).string(message.destinationAddress);
        }
        if (message.tokens !== undefined) {
            coin_1.Coin.encode(message.tokens, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgAxelarSendToken);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.destinationChain = reader.string();
                    break;
                case 3:
                    message.destinationAddress = reader.string();
                    break;
                case 4:
                    message.tokens = coin_1.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgAxelarSendToken);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.destinationChain =
            object.destinationChain !== undefined && object.destinationChain !== null
                ? String(object.destinationChain)
                : "";
        message.destinationAddress =
            object.destinationAddress !== undefined &&
                object.destinationAddress !== null
                ? String(object.destinationAddress)
                : "";
        message.tokens =
            object.tokens !== undefined && object.tokens !== null
                ? coin_1.Coin.fromJSON(object.tokens)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.destinationChain !== undefined &&
            (obj.destinationChain = message.destinationChain);
        message.destinationAddress !== undefined &&
            (obj.destinationAddress = message.destinationAddress);
        message.tokens !== undefined &&
            (obj.tokens = message.tokens ? coin_1.Coin.toJSON(message.tokens) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = Object.assign({}, baseMsgAxelarSendToken);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.destinationChain = (_b = object.destinationChain) !== null && _b !== void 0 ? _b : "";
        message.destinationAddress = (_c = object.destinationAddress) !== null && _c !== void 0 ? _c : "";
        message.tokens =
            object.tokens !== undefined && object.tokens !== null
                ? coin_1.Coin.fromPartial(object.tokens)
                : undefined;
        return message;
    },
};
const baseMsgAxelarSendTokenResponse = {};
exports.MsgAxelarSendTokenResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgAxelarSendTokenResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgAxelarSendTokenResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgAxelarSendTokenResponse);
        return message;
    },
};
const baseMsgAxelarCallContract = {
    creator: "",
    destinationChain: "",
    destinationAddress: "",
};
exports.MsgAxelarCallContract = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.destinationChain !== "") {
            writer.uint32(18).string(message.destinationChain);
        }
        if (message.destinationAddress !== "") {
            writer.uint32(26).string(message.destinationAddress);
        }
        if (message.payload.length !== 0) {
            writer.uint32(34).bytes(message.payload);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgAxelarCallContract);
        message.payload = new Uint8Array();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.destinationChain = reader.string();
                    break;
                case 3:
                    message.destinationAddress = reader.string();
                    break;
                case 4:
                    message.payload = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgAxelarCallContract);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.destinationChain =
            object.destinationChain !== undefined && object.destinationChain !== null
                ? String(object.destinationChain)
                : "";
        message.destinationAddress =
            object.destinationAddress !== undefined &&
                object.destinationAddress !== null
                ? String(object.destinationAddress)
                : "";
        message.payload =
            object.payload !== undefined && object.payload !== null
                ? bytesFromBase64(object.payload)
                : new Uint8Array();
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.destinationChain !== undefined &&
            (obj.destinationChain = message.destinationChain);
        message.destinationAddress !== undefined &&
            (obj.destinationAddress = message.destinationAddress);
        message.payload !== undefined &&
            (obj.payload = base64FromBytes(message.payload !== undefined ? message.payload : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = Object.assign({}, baseMsgAxelarCallContract);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.destinationChain = (_b = object.destinationChain) !== null && _b !== void 0 ? _b : "";
        message.destinationAddress = (_c = object.destinationAddress) !== null && _c !== void 0 ? _c : "";
        message.payload = (_d = object.payload) !== null && _d !== void 0 ? _d : new Uint8Array();
        return message;
    },
};
const baseMsgAxelarCallContractResponse = {};
exports.MsgAxelarCallContractResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgAxelarCallContractResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgAxelarCallContractResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgAxelarCallContractResponse);
        return message;
    },
};
const baseMsgAxelarCallContractWithToken = {
    creator: "",
    destinationChain: "",
    destinationAddress: "",
};
exports.MsgAxelarCallContractWithToken = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.destinationChain !== "") {
            writer.uint32(18).string(message.destinationChain);
        }
        if (message.destinationAddress !== "") {
            writer.uint32(26).string(message.destinationAddress);
        }
        if (message.tokens !== undefined) {
            coin_1.Coin.encode(message.tokens, writer.uint32(34).fork()).ldelim();
        }
        if (message.payload.length !== 0) {
            writer.uint32(42).bytes(message.payload);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgAxelarCallContractWithToken);
        message.payload = new Uint8Array();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.destinationChain = reader.string();
                    break;
                case 3:
                    message.destinationAddress = reader.string();
                    break;
                case 4:
                    message.tokens = coin_1.Coin.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.payload = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgAxelarCallContractWithToken);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.destinationChain =
            object.destinationChain !== undefined && object.destinationChain !== null
                ? String(object.destinationChain)
                : "";
        message.destinationAddress =
            object.destinationAddress !== undefined &&
                object.destinationAddress !== null
                ? String(object.destinationAddress)
                : "";
        message.tokens =
            object.tokens !== undefined && object.tokens !== null
                ? coin_1.Coin.fromJSON(object.tokens)
                : undefined;
        message.payload =
            object.payload !== undefined && object.payload !== null
                ? bytesFromBase64(object.payload)
                : new Uint8Array();
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.destinationChain !== undefined &&
            (obj.destinationChain = message.destinationChain);
        message.destinationAddress !== undefined &&
            (obj.destinationAddress = message.destinationAddress);
        message.tokens !== undefined &&
            (obj.tokens = message.tokens ? coin_1.Coin.toJSON(message.tokens) : undefined);
        message.payload !== undefined &&
            (obj.payload = base64FromBytes(message.payload !== undefined ? message.payload : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = Object.assign({}, baseMsgAxelarCallContractWithToken);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.destinationChain = (_b = object.destinationChain) !== null && _b !== void 0 ? _b : "";
        message.destinationAddress = (_c = object.destinationAddress) !== null && _c !== void 0 ? _c : "";
        message.tokens =
            object.tokens !== undefined && object.tokens !== null
                ? coin_1.Coin.fromPartial(object.tokens)
                : undefined;
        message.payload = (_d = object.payload) !== null && _d !== void 0 ? _d : new Uint8Array();
        return message;
    },
};
const baseMsgAxelarCallContractWithTokenResponse = {};
exports.MsgAxelarCallContractWithTokenResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgAxelarCallContractWithTokenResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgAxelarCallContractWithTokenResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgAxelarCallContractWithTokenResponse);
        return message;
    },
};
const baseMsgCreateConnection = {
    creator: "",
    bridgeId: long_1.default.UZERO,
    chainId: "",
    chainDisplayName: "",
    tokenGatewayAddress: "",
    encoding: "",
    isEnabled: false,
    isOptimisticConfirm: false,
};
exports.MsgCreateConnection = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (!message.bridgeId.isZero()) {
            writer.uint32(16).uint64(message.bridgeId);
        }
        if (message.chainId !== "") {
            writer.uint32(26).string(message.chainId);
        }
        if (message.chainDisplayName !== "") {
            writer.uint32(34).string(message.chainDisplayName);
        }
        if (message.tokenGatewayAddress !== "") {
            writer.uint32(42).string(message.tokenGatewayAddress);
        }
        if (message.encoding !== "") {
            writer.uint32(50).string(message.encoding);
        }
        if (message.isEnabled === true) {
            writer.uint32(56).bool(message.isEnabled);
        }
        if (message.isOptimisticConfirm === true) {
            writer.uint32(64).bool(message.isOptimisticConfirm);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgCreateConnection);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.bridgeId = reader.uint64();
                    break;
                case 3:
                    message.chainId = reader.string();
                    break;
                case 4:
                    message.chainDisplayName = reader.string();
                    break;
                case 5:
                    message.tokenGatewayAddress = reader.string();
                    break;
                case 6:
                    message.encoding = reader.string();
                    break;
                case 7:
                    message.isEnabled = reader.bool();
                    break;
                case 8:
                    message.isOptimisticConfirm = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgCreateConnection);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.bridgeId =
            object.bridgeId !== undefined && object.bridgeId !== null
                ? long_1.default.fromString(object.bridgeId)
                : long_1.default.UZERO;
        message.chainId =
            object.chainId !== undefined && object.chainId !== null
                ? String(object.chainId)
                : "";
        message.chainDisplayName =
            object.chainDisplayName !== undefined && object.chainDisplayName !== null
                ? String(object.chainDisplayName)
                : "";
        message.tokenGatewayAddress =
            object.tokenGatewayAddress !== undefined &&
                object.tokenGatewayAddress !== null
                ? String(object.tokenGatewayAddress)
                : "";
        message.encoding =
            object.encoding !== undefined && object.encoding !== null
                ? String(object.encoding)
                : "";
        message.isEnabled =
            object.isEnabled !== undefined && object.isEnabled !== null
                ? Boolean(object.isEnabled)
                : false;
        message.isOptimisticConfirm =
            object.isOptimisticConfirm !== undefined &&
                object.isOptimisticConfirm !== null
                ? Boolean(object.isOptimisticConfirm)
                : false;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.bridgeId !== undefined &&
            (obj.bridgeId = (message.bridgeId || long_1.default.UZERO).toString());
        message.chainId !== undefined && (obj.chainId = message.chainId);
        message.chainDisplayName !== undefined &&
            (obj.chainDisplayName = message.chainDisplayName);
        message.tokenGatewayAddress !== undefined &&
            (obj.tokenGatewayAddress = message.tokenGatewayAddress);
        message.encoding !== undefined && (obj.encoding = message.encoding);
        message.isEnabled !== undefined && (obj.isEnabled = message.isEnabled);
        message.isOptimisticConfirm !== undefined &&
            (obj.isOptimisticConfirm = message.isOptimisticConfirm);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g;
        const message = Object.assign({}, baseMsgCreateConnection);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.bridgeId =
            object.bridgeId !== undefined && object.bridgeId !== null
                ? long_1.default.fromValue(object.bridgeId)
                : long_1.default.UZERO;
        message.chainId = (_b = object.chainId) !== null && _b !== void 0 ? _b : "";
        message.chainDisplayName = (_c = object.chainDisplayName) !== null && _c !== void 0 ? _c : "";
        message.tokenGatewayAddress = (_d = object.tokenGatewayAddress) !== null && _d !== void 0 ? _d : "";
        message.encoding = (_e = object.encoding) !== null && _e !== void 0 ? _e : "";
        message.isEnabled = (_f = object.isEnabled) !== null && _f !== void 0 ? _f : false;
        message.isOptimisticConfirm = (_g = object.isOptimisticConfirm) !== null && _g !== void 0 ? _g : false;
        return message;
    },
};
const baseMsgCreateConnectionResponse = {};
exports.MsgCreateConnectionResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgCreateConnectionResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgCreateConnectionResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgCreateConnectionResponse);
        return message;
    },
};
const baseMsgUpdateConnection = { creator: "", connectionId: "" };
exports.MsgUpdateConnection = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.connectionId !== "") {
            writer.uint32(18).string(message.connectionId);
        }
        if (message.updateConnectionParams !== undefined) {
            exports.UpdateConnectionParams.encode(message.updateConnectionParams, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgUpdateConnection);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.connectionId = reader.string();
                    break;
                case 3:
                    message.updateConnectionParams = exports.UpdateConnectionParams.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgUpdateConnection);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.connectionId =
            object.connectionId !== undefined && object.connectionId !== null
                ? String(object.connectionId)
                : "";
        message.updateConnectionParams =
            object.updateConnectionParams !== undefined &&
                object.updateConnectionParams !== null
                ? exports.UpdateConnectionParams.fromJSON(object.updateConnectionParams)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.connectionId !== undefined &&
            (obj.connectionId = message.connectionId);
        message.updateConnectionParams !== undefined &&
            (obj.updateConnectionParams = message.updateConnectionParams
                ? exports.UpdateConnectionParams.toJSON(message.updateConnectionParams)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseMsgUpdateConnection);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.connectionId = (_b = object.connectionId) !== null && _b !== void 0 ? _b : "";
        message.updateConnectionParams =
            object.updateConnectionParams !== undefined &&
                object.updateConnectionParams !== null
                ? exports.UpdateConnectionParams.fromPartial(object.updateConnectionParams)
                : undefined;
        return message;
    },
};
const baseUpdateConnectionParams = {};
exports.UpdateConnectionParams = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.chainDisplayName !== undefined) {
            wrappers_1.StringValue.encode({ value: message.chainDisplayName }, writer.uint32(10).fork()).ldelim();
        }
        if (message.isEnabled !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.isEnabled }, writer.uint32(18).fork()).ldelim();
        }
        if (message.isOptimisticConfirm !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.isOptimisticConfirm }, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseUpdateConnectionParams);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.chainDisplayName = wrappers_1.StringValue.decode(reader, reader.uint32()).value;
                    break;
                case 2:
                    message.isEnabled = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 3:
                    message.isOptimisticConfirm = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseUpdateConnectionParams);
        message.chainDisplayName =
            object.chainDisplayName !== undefined && object.chainDisplayName !== null
                ? String(object.chainDisplayName)
                : undefined;
        message.isEnabled =
            object.isEnabled !== undefined && object.isEnabled !== null
                ? Boolean(object.isEnabled)
                : undefined;
        message.isOptimisticConfirm =
            object.isOptimisticConfirm !== undefined &&
                object.isOptimisticConfirm !== null
                ? Boolean(object.isOptimisticConfirm)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.chainDisplayName !== undefined &&
            (obj.chainDisplayName = message.chainDisplayName);
        message.isEnabled !== undefined && (obj.isEnabled = message.isEnabled);
        message.isOptimisticConfirm !== undefined &&
            (obj.isOptimisticConfirm = message.isOptimisticConfirm);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = Object.assign({}, baseUpdateConnectionParams);
        message.chainDisplayName = (_a = object.chainDisplayName) !== null && _a !== void 0 ? _a : undefined;
        message.isEnabled = (_b = object.isEnabled) !== null && _b !== void 0 ? _b : undefined;
        message.isOptimisticConfirm = (_c = object.isOptimisticConfirm) !== null && _c !== void 0 ? _c : undefined;
        return message;
    },
};
const baseMsgUpdateConnectionResponse = {};
exports.MsgUpdateConnectionResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgUpdateConnectionResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgUpdateConnectionResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgUpdateConnectionResponse);
        return message;
    },
};
const baseMsgRemoveConnection = { creator: "", connectionId: "" };
exports.MsgRemoveConnection = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.connectionId !== "") {
            writer.uint32(18).string(message.connectionId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgRemoveConnection);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.connectionId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgRemoveConnection);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.connectionId =
            object.connectionId !== undefined && object.connectionId !== null
                ? String(object.connectionId)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.connectionId !== undefined &&
            (obj.connectionId = message.connectionId);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseMsgRemoveConnection);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.connectionId = (_b = object.connectionId) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
const baseMsgRemoveConnectionResponse = {};
exports.MsgRemoveConnectionResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgRemoveConnectionResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgRemoveConnectionResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgRemoveConnectionResponse);
        return message;
    },
};
const baseMsgAddControllersForConnection = { creator: "" };
exports.MsgAddControllersForConnection = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.controllers !== undefined) {
            bridge_1.ControllerContracts.encode(message.controllers, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgAddControllersForConnection);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.controllers = bridge_1.ControllerContracts.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgAddControllersForConnection);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.controllers =
            object.controllers !== undefined && object.controllers !== null
                ? bridge_1.ControllerContracts.fromJSON(object.controllers)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.controllers !== undefined &&
            (obj.controllers = message.controllers
                ? bridge_1.ControllerContracts.toJSON(message.controllers)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseMsgAddControllersForConnection);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.controllers =
            object.controllers !== undefined && object.controllers !== null
                ? bridge_1.ControllerContracts.fromPartial(object.controllers)
                : undefined;
        return message;
    },
};
const baseMsgAddControllersForConnectionResponse = {};
exports.MsgAddControllersForConnectionResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgAddControllersForConnectionResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgAddControllersForConnectionResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgAddControllersForConnectionResponse);
        return message;
    },
};
const baseMsgUpdateControllersForConnection = {
    creator: "",
    connectionId: "",
};
exports.MsgUpdateControllersForConnection = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.connectionId !== "") {
            writer.uint32(18).string(message.connectionId);
        }
        if (message.controllers !== undefined) {
            bridge_1.ControllersToUpdate.encode(message.controllers, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgUpdateControllersForConnection);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.connectionId = reader.string();
                    break;
                case 3:
                    message.controllers = bridge_1.ControllersToUpdate.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgUpdateControllersForConnection);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.connectionId =
            object.connectionId !== undefined && object.connectionId !== null
                ? String(object.connectionId)
                : "";
        message.controllers =
            object.controllers !== undefined && object.controllers !== null
                ? bridge_1.ControllersToUpdate.fromJSON(object.controllers)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.connectionId !== undefined &&
            (obj.connectionId = message.connectionId);
        message.controllers !== undefined &&
            (obj.controllers = message.controllers
                ? bridge_1.ControllersToUpdate.toJSON(message.controllers)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseMsgUpdateControllersForConnection);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.connectionId = (_b = object.connectionId) !== null && _b !== void 0 ? _b : "";
        message.controllers =
            object.controllers !== undefined && object.controllers !== null
                ? bridge_1.ControllersToUpdate.fromPartial(object.controllers)
                : undefined;
        return message;
    },
};
const baseMsgUpdateControllersForConnectionResponse = {};
exports.MsgUpdateControllersForConnectionResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgUpdateControllersForConnectionResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgUpdateControllersForConnectionResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgUpdateControllersForConnectionResponse);
        return message;
    },
};
const baseMsgRemoveControllersForConnection = {
    creator: "",
    connectionId: "",
};
exports.MsgRemoveControllersForConnection = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.connectionId !== "") {
            writer.uint32(18).string(message.connectionId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgRemoveControllersForConnection);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.connectionId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgRemoveControllersForConnection);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.connectionId =
            object.connectionId !== undefined && object.connectionId !== null
                ? String(object.connectionId)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.connectionId !== undefined &&
            (obj.connectionId = message.connectionId);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseMsgRemoveControllersForConnection);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.connectionId = (_b = object.connectionId) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
const baseMsgRemoveControllersForConnectionResponse = {};
exports.MsgRemoveControllersForConnectionResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgRemoveControllersForConnectionResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgRemoveControllersForConnectionResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgRemoveControllersForConnectionResponse);
        return message;
    },
};
const baseMsgRemoveNonceMapForConnection = {
    creator: "",
    connectionId: "",
    gatewayAddress: "",
};
exports.MsgRemoveNonceMapForConnection = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.connectionId !== "") {
            writer.uint32(18).string(message.connectionId);
        }
        if (message.gatewayAddress !== "") {
            writer.uint32(26).string(message.gatewayAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgRemoveNonceMapForConnection);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.connectionId = reader.string();
                    break;
                case 3:
                    message.gatewayAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgRemoveNonceMapForConnection);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.connectionId =
            object.connectionId !== undefined && object.connectionId !== null
                ? String(object.connectionId)
                : "";
        message.gatewayAddress =
            object.gatewayAddress !== undefined && object.gatewayAddress !== null
                ? String(object.gatewayAddress)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.connectionId !== undefined &&
            (obj.connectionId = message.connectionId);
        message.gatewayAddress !== undefined &&
            (obj.gatewayAddress = message.gatewayAddress);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = Object.assign({}, baseMsgRemoveNonceMapForConnection);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.connectionId = (_b = object.connectionId) !== null && _b !== void 0 ? _b : "";
        message.gatewayAddress = (_c = object.gatewayAddress) !== null && _c !== void 0 ? _c : "";
        return message;
    },
};
const baseMsgRemoveNonceMapForConnectionResponse = {};
exports.MsgRemoveNonceMapForConnectionResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgRemoveNonceMapForConnectionResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgRemoveNonceMapForConnectionResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgRemoveNonceMapForConnectionResponse);
        return message;
    },
};
const baseMsgRegisterExternalToken = {
    creator: "",
    connectionId: "",
    assetAddress: "",
};
exports.MsgRegisterExternalToken = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.connectionId !== "") {
            writer.uint32(18).string(message.connectionId);
        }
        if (message.assetAddress !== "") {
            writer.uint32(26).string(message.assetAddress);
        }
        if (message.decimals !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.decimals }, writer.uint32(34).fork()).ldelim();
        }
        if (message.carbonTokenName !== undefined) {
            wrappers_1.StringValue.encode({ value: message.carbonTokenName }, writer.uint32(42).fork()).ldelim();
        }
        if (message.relayFee !== undefined) {
            coin_1.Coin.encode(message.relayFee, writer.uint32(50).fork()).ldelim();
        }
        if (message.expiryDuration !== undefined) {
            duration_1.Duration.encode(message.expiryDuration, writer.uint32(58).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgRegisterExternalToken);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.connectionId = reader.string();
                    break;
                case 3:
                    message.assetAddress = reader.string();
                    break;
                case 4:
                    message.decimals = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 5:
                    message.carbonTokenName = wrappers_1.StringValue.decode(reader, reader.uint32()).value;
                    break;
                case 6:
                    message.relayFee = coin_1.Coin.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.expiryDuration = duration_1.Duration.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgRegisterExternalToken);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.connectionId =
            object.connectionId !== undefined && object.connectionId !== null
                ? String(object.connectionId)
                : "";
        message.assetAddress =
            object.assetAddress !== undefined && object.assetAddress !== null
                ? String(object.assetAddress)
                : "";
        message.decimals =
            object.decimals !== undefined && object.decimals !== null
                ? long_1.default.fromValue(object.decimals)
                : undefined;
        message.carbonTokenName =
            object.carbonTokenName !== undefined && object.carbonTokenName !== null
                ? String(object.carbonTokenName)
                : undefined;
        message.relayFee =
            object.relayFee !== undefined && object.relayFee !== null
                ? coin_1.Coin.fromJSON(object.relayFee)
                : undefined;
        message.expiryDuration =
            object.expiryDuration !== undefined && object.expiryDuration !== null
                ? duration_1.Duration.fromJSON(object.expiryDuration)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.connectionId !== undefined &&
            (obj.connectionId = message.connectionId);
        message.assetAddress !== undefined &&
            (obj.assetAddress = message.assetAddress);
        message.decimals !== undefined && (obj.decimals = message.decimals);
        message.carbonTokenName !== undefined &&
            (obj.carbonTokenName = message.carbonTokenName);
        message.relayFee !== undefined &&
            (obj.relayFee = message.relayFee
                ? coin_1.Coin.toJSON(message.relayFee)
                : undefined);
        message.expiryDuration !== undefined &&
            (obj.expiryDuration = message.expiryDuration
                ? duration_1.Duration.toJSON(message.expiryDuration)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = Object.assign({}, baseMsgRegisterExternalToken);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.connectionId = (_b = object.connectionId) !== null && _b !== void 0 ? _b : "";
        message.assetAddress = (_c = object.assetAddress) !== null && _c !== void 0 ? _c : "";
        message.decimals =
            object.decimals !== undefined && object.decimals !== null
                ? long_1.default.fromValue(object.decimals)
                : undefined;
        message.carbonTokenName = (_d = object.carbonTokenName) !== null && _d !== void 0 ? _d : undefined;
        message.relayFee =
            object.relayFee !== undefined && object.relayFee !== null
                ? coin_1.Coin.fromPartial(object.relayFee)
                : undefined;
        message.expiryDuration =
            object.expiryDuration !== undefined && object.expiryDuration !== null
                ? duration_1.Duration.fromPartial(object.expiryDuration)
                : undefined;
        return message;
    },
};
const baseMsgRegisterExternalTokenResponse = {};
exports.MsgRegisterExternalTokenResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgRegisterExternalTokenResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgRegisterExternalTokenResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgRegisterExternalTokenResponse);
        return message;
    },
};
const baseMsgDeregisterExternalToken = {
    creator: "",
    connectionId: "",
    denom: "",
};
exports.MsgDeregisterExternalToken = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.connectionId !== "") {
            writer.uint32(18).string(message.connectionId);
        }
        if (message.denom !== "") {
            writer.uint32(26).string(message.denom);
        }
        if (message.relayFee !== undefined) {
            coin_1.Coin.encode(message.relayFee, writer.uint32(34).fork()).ldelim();
        }
        if (message.expiryDuration !== undefined) {
            duration_1.Duration.encode(message.expiryDuration, writer.uint32(42).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgDeregisterExternalToken);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.connectionId = reader.string();
                    break;
                case 3:
                    message.denom = reader.string();
                    break;
                case 4:
                    message.relayFee = coin_1.Coin.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.expiryDuration = duration_1.Duration.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgDeregisterExternalToken);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.connectionId =
            object.connectionId !== undefined && object.connectionId !== null
                ? String(object.connectionId)
                : "";
        message.denom =
            object.denom !== undefined && object.denom !== null
                ? String(object.denom)
                : "";
        message.relayFee =
            object.relayFee !== undefined && object.relayFee !== null
                ? coin_1.Coin.fromJSON(object.relayFee)
                : undefined;
        message.expiryDuration =
            object.expiryDuration !== undefined && object.expiryDuration !== null
                ? duration_1.Duration.fromJSON(object.expiryDuration)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.connectionId !== undefined &&
            (obj.connectionId = message.connectionId);
        message.denom !== undefined && (obj.denom = message.denom);
        message.relayFee !== undefined &&
            (obj.relayFee = message.relayFee
                ? coin_1.Coin.toJSON(message.relayFee)
                : undefined);
        message.expiryDuration !== undefined &&
            (obj.expiryDuration = message.expiryDuration
                ? duration_1.Duration.toJSON(message.expiryDuration)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = Object.assign({}, baseMsgDeregisterExternalToken);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.connectionId = (_b = object.connectionId) !== null && _b !== void 0 ? _b : "";
        message.denom = (_c = object.denom) !== null && _c !== void 0 ? _c : "";
        message.relayFee =
            object.relayFee !== undefined && object.relayFee !== null
                ? coin_1.Coin.fromPartial(object.relayFee)
                : undefined;
        message.expiryDuration =
            object.expiryDuration !== undefined && object.expiryDuration !== null
                ? duration_1.Duration.fromPartial(object.expiryDuration)
                : undefined;
        return message;
    },
};
const baseMsgDeregisterExternalTokenResponse = {};
exports.MsgDeregisterExternalTokenResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgDeregisterExternalTokenResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgDeregisterExternalTokenResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgDeregisterExternalTokenResponse);
        return message;
    },
};
const baseMsgDeployNativeToken = {
    creator: "",
    connectionId: "",
    denom: "",
};
exports.MsgDeployNativeToken = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.connectionId !== "") {
            writer.uint32(18).string(message.connectionId);
        }
        if (message.denom !== "") {
            writer.uint32(26).string(message.denom);
        }
        if (message.relayFee !== undefined) {
            coin_1.Coin.encode(message.relayFee, writer.uint32(34).fork()).ldelim();
        }
        if (message.expiryDuration !== undefined) {
            duration_1.Duration.encode(message.expiryDuration, writer.uint32(42).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgDeployNativeToken);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.connectionId = reader.string();
                    break;
                case 3:
                    message.denom = reader.string();
                    break;
                case 4:
                    message.relayFee = coin_1.Coin.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.expiryDuration = duration_1.Duration.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgDeployNativeToken);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.connectionId =
            object.connectionId !== undefined && object.connectionId !== null
                ? String(object.connectionId)
                : "";
        message.denom =
            object.denom !== undefined && object.denom !== null
                ? String(object.denom)
                : "";
        message.relayFee =
            object.relayFee !== undefined && object.relayFee !== null
                ? coin_1.Coin.fromJSON(object.relayFee)
                : undefined;
        message.expiryDuration =
            object.expiryDuration !== undefined && object.expiryDuration !== null
                ? duration_1.Duration.fromJSON(object.expiryDuration)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.connectionId !== undefined &&
            (obj.connectionId = message.connectionId);
        message.denom !== undefined && (obj.denom = message.denom);
        message.relayFee !== undefined &&
            (obj.relayFee = message.relayFee
                ? coin_1.Coin.toJSON(message.relayFee)
                : undefined);
        message.expiryDuration !== undefined &&
            (obj.expiryDuration = message.expiryDuration
                ? duration_1.Duration.toJSON(message.expiryDuration)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = Object.assign({}, baseMsgDeployNativeToken);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.connectionId = (_b = object.connectionId) !== null && _b !== void 0 ? _b : "";
        message.denom = (_c = object.denom) !== null && _c !== void 0 ? _c : "";
        message.relayFee =
            object.relayFee !== undefined && object.relayFee !== null
                ? coin_1.Coin.fromPartial(object.relayFee)
                : undefined;
        message.expiryDuration =
            object.expiryDuration !== undefined && object.expiryDuration !== null
                ? duration_1.Duration.fromPartial(object.expiryDuration)
                : undefined;
        return message;
    },
};
const baseMsgDeployNativeTokenResponse = {};
exports.MsgDeployNativeTokenResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgDeployNativeTokenResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgDeployNativeTokenResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgDeployNativeTokenResponse);
        return message;
    },
};
const baseMsgRegisterDeployedToken = {
    creator: "",
    connectionId: "",
    tokenAddress: "",
    denom: "",
};
exports.MsgRegisterDeployedToken = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.connectionId !== "") {
            writer.uint32(18).string(message.connectionId);
        }
        if (message.tokenAddress !== "") {
            writer.uint32(26).string(message.tokenAddress);
        }
        if (message.denom !== "") {
            writer.uint32(34).string(message.denom);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgRegisterDeployedToken);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.connectionId = reader.string();
                    break;
                case 3:
                    message.tokenAddress = reader.string();
                    break;
                case 4:
                    message.denom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgRegisterDeployedToken);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.connectionId =
            object.connectionId !== undefined && object.connectionId !== null
                ? String(object.connectionId)
                : "";
        message.tokenAddress =
            object.tokenAddress !== undefined && object.tokenAddress !== null
                ? String(object.tokenAddress)
                : "";
        message.denom =
            object.denom !== undefined && object.denom !== null
                ? String(object.denom)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.connectionId !== undefined &&
            (obj.connectionId = message.connectionId);
        message.tokenAddress !== undefined &&
            (obj.tokenAddress = message.tokenAddress);
        message.denom !== undefined && (obj.denom = message.denom);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = Object.assign({}, baseMsgRegisterDeployedToken);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.connectionId = (_b = object.connectionId) !== null && _b !== void 0 ? _b : "";
        message.tokenAddress = (_c = object.tokenAddress) !== null && _c !== void 0 ? _c : "";
        message.denom = (_d = object.denom) !== null && _d !== void 0 ? _d : "";
        return message;
    },
};
const baseMsgRegisterDeployedTokenResponse = {};
exports.MsgRegisterDeployedTokenResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgRegisterDeployedTokenResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgRegisterDeployedTokenResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgRegisterDeployedTokenResponse);
        return message;
    },
};
const baseMsgWithdrawToken = {
    creator: "",
    connectionId: "",
    receiver: "",
};
exports.MsgWithdrawToken = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.connectionId !== "") {
            writer.uint32(18).string(message.connectionId);
        }
        if (message.receiver !== "") {
            writer.uint32(26).string(message.receiver);
        }
        if (message.tokens !== undefined) {
            coin_1.Coin.encode(message.tokens, writer.uint32(34).fork()).ldelim();
        }
        if (message.relayFee !== undefined) {
            coin_1.Coin.encode(message.relayFee, writer.uint32(42).fork()).ldelim();
        }
        if (message.expiryDuration !== undefined) {
            duration_1.Duration.encode(message.expiryDuration, writer.uint32(50).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgWithdrawToken);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.connectionId = reader.string();
                    break;
                case 3:
                    message.receiver = reader.string();
                    break;
                case 4:
                    message.tokens = coin_1.Coin.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.relayFee = coin_1.Coin.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.expiryDuration = duration_1.Duration.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgWithdrawToken);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.connectionId =
            object.connectionId !== undefined && object.connectionId !== null
                ? String(object.connectionId)
                : "";
        message.receiver =
            object.receiver !== undefined && object.receiver !== null
                ? String(object.receiver)
                : "";
        message.tokens =
            object.tokens !== undefined && object.tokens !== null
                ? coin_1.Coin.fromJSON(object.tokens)
                : undefined;
        message.relayFee =
            object.relayFee !== undefined && object.relayFee !== null
                ? coin_1.Coin.fromJSON(object.relayFee)
                : undefined;
        message.expiryDuration =
            object.expiryDuration !== undefined && object.expiryDuration !== null
                ? duration_1.Duration.fromJSON(object.expiryDuration)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.connectionId !== undefined &&
            (obj.connectionId = message.connectionId);
        message.receiver !== undefined && (obj.receiver = message.receiver);
        message.tokens !== undefined &&
            (obj.tokens = message.tokens ? coin_1.Coin.toJSON(message.tokens) : undefined);
        message.relayFee !== undefined &&
            (obj.relayFee = message.relayFee
                ? coin_1.Coin.toJSON(message.relayFee)
                : undefined);
        message.expiryDuration !== undefined &&
            (obj.expiryDuration = message.expiryDuration
                ? duration_1.Duration.toJSON(message.expiryDuration)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = Object.assign({}, baseMsgWithdrawToken);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.connectionId = (_b = object.connectionId) !== null && _b !== void 0 ? _b : "";
        message.receiver = (_c = object.receiver) !== null && _c !== void 0 ? _c : "";
        message.tokens =
            object.tokens !== undefined && object.tokens !== null
                ? coin_1.Coin.fromPartial(object.tokens)
                : undefined;
        message.relayFee =
            object.relayFee !== undefined && object.relayFee !== null
                ? coin_1.Coin.fromPartial(object.relayFee)
                : undefined;
        message.expiryDuration =
            object.expiryDuration !== undefined && object.expiryDuration !== null
                ? duration_1.Duration.fromPartial(object.expiryDuration)
                : undefined;
        return message;
    },
};
const baseMsgWithdrawTokenResponse = {};
exports.MsgWithdrawTokenResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgWithdrawTokenResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgWithdrawTokenResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgWithdrawTokenResponse);
        return message;
    },
};
const baseMsgUpdateExternalToken = {
    creator: "",
    connectionId: "",
    assetAddress: "",
    tokenName: "",
    decimals: long_1.default.ZERO,
    isCarbonOwned: false,
};
exports.MsgUpdateExternalToken = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.connectionId !== "") {
            writer.uint32(18).string(message.connectionId);
        }
        if (message.assetAddress !== "") {
            writer.uint32(26).string(message.assetAddress);
        }
        if (message.tokenName !== "") {
            writer.uint32(34).string(message.tokenName);
        }
        if (!message.decimals.isZero()) {
            writer.uint32(40).int64(message.decimals);
        }
        if (message.isCarbonOwned === true) {
            writer.uint32(48).bool(message.isCarbonOwned);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgUpdateExternalToken);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.connectionId = reader.string();
                    break;
                case 3:
                    message.assetAddress = reader.string();
                    break;
                case 4:
                    message.tokenName = reader.string();
                    break;
                case 5:
                    message.decimals = reader.int64();
                    break;
                case 6:
                    message.isCarbonOwned = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgUpdateExternalToken);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.connectionId =
            object.connectionId !== undefined && object.connectionId !== null
                ? String(object.connectionId)
                : "";
        message.assetAddress =
            object.assetAddress !== undefined && object.assetAddress !== null
                ? String(object.assetAddress)
                : "";
        message.tokenName =
            object.tokenName !== undefined && object.tokenName !== null
                ? String(object.tokenName)
                : "";
        message.decimals =
            object.decimals !== undefined && object.decimals !== null
                ? long_1.default.fromString(object.decimals)
                : long_1.default.ZERO;
        message.isCarbonOwned =
            object.isCarbonOwned !== undefined && object.isCarbonOwned !== null
                ? Boolean(object.isCarbonOwned)
                : false;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.connectionId !== undefined &&
            (obj.connectionId = message.connectionId);
        message.assetAddress !== undefined &&
            (obj.assetAddress = message.assetAddress);
        message.tokenName !== undefined && (obj.tokenName = message.tokenName);
        message.decimals !== undefined &&
            (obj.decimals = (message.decimals || long_1.default.ZERO).toString());
        message.isCarbonOwned !== undefined &&
            (obj.isCarbonOwned = message.isCarbonOwned);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = Object.assign({}, baseMsgUpdateExternalToken);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.connectionId = (_b = object.connectionId) !== null && _b !== void 0 ? _b : "";
        message.assetAddress = (_c = object.assetAddress) !== null && _c !== void 0 ? _c : "";
        message.tokenName = (_d = object.tokenName) !== null && _d !== void 0 ? _d : "";
        message.decimals =
            object.decimals !== undefined && object.decimals !== null
                ? long_1.default.fromValue(object.decimals)
                : long_1.default.ZERO;
        message.isCarbonOwned = (_e = object.isCarbonOwned) !== null && _e !== void 0 ? _e : false;
        return message;
    },
};
const baseMsgUpdateExternalTokenResponse = {};
exports.MsgUpdateExternalTokenResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgUpdateExternalTokenResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgUpdateExternalTokenResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgUpdateExternalTokenResponse);
        return message;
    },
};
const baseMsgDeleteExternalToken = {
    creator: "",
    connectionId: "",
    denom: "",
};
exports.MsgDeleteExternalToken = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.connectionId !== "") {
            writer.uint32(18).string(message.connectionId);
        }
        if (message.denom !== "") {
            writer.uint32(26).string(message.denom);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgDeleteExternalToken);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.connectionId = reader.string();
                    break;
                case 3:
                    message.denom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgDeleteExternalToken);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.connectionId =
            object.connectionId !== undefined && object.connectionId !== null
                ? String(object.connectionId)
                : "";
        message.denom =
            object.denom !== undefined && object.denom !== null
                ? String(object.denom)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.connectionId !== undefined &&
            (obj.connectionId = message.connectionId);
        message.denom !== undefined && (obj.denom = message.denom);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = Object.assign({}, baseMsgDeleteExternalToken);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.connectionId = (_b = object.connectionId) !== null && _b !== void 0 ? _b : "";
        message.denom = (_c = object.denom) !== null && _c !== void 0 ? _c : "";
        return message;
    },
};
const baseMsgDeleteExternalTokenResponse = {};
exports.MsgDeleteExternalTokenResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgDeleteExternalTokenResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgDeleteExternalTokenResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgDeleteExternalTokenResponse);
        return message;
    },
};
const baseMsgExecuteFromCarbon = {
    creator: "",
    connectionId: "",
    executionContract: "",
    method: "",
};
exports.MsgExecuteFromCarbon = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.connectionId !== "") {
            writer.uint32(18).string(message.connectionId);
        }
        if (message.executionContract !== "") {
            writer.uint32(26).string(message.executionContract);
        }
        if (message.method !== "") {
            writer.uint32(34).string(message.method);
        }
        if (message.executionBytes.length !== 0) {
            writer.uint32(42).bytes(message.executionBytes);
        }
        if (message.tokens !== undefined) {
            coin_1.Coin.encode(message.tokens, writer.uint32(50).fork()).ldelim();
        }
        if (message.relayFee !== undefined) {
            coin_1.Coin.encode(message.relayFee, writer.uint32(58).fork()).ldelim();
        }
        if (message.expiryDuration !== undefined) {
            duration_1.Duration.encode(message.expiryDuration, writer.uint32(66).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgExecuteFromCarbon);
        message.executionBytes = new Uint8Array();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.connectionId = reader.string();
                    break;
                case 3:
                    message.executionContract = reader.string();
                    break;
                case 4:
                    message.method = reader.string();
                    break;
                case 5:
                    message.executionBytes = reader.bytes();
                    break;
                case 6:
                    message.tokens = coin_1.Coin.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.relayFee = coin_1.Coin.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.expiryDuration = duration_1.Duration.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgExecuteFromCarbon);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.connectionId =
            object.connectionId !== undefined && object.connectionId !== null
                ? String(object.connectionId)
                : "";
        message.executionContract =
            object.executionContract !== undefined &&
                object.executionContract !== null
                ? String(object.executionContract)
                : "";
        message.method =
            object.method !== undefined && object.method !== null
                ? String(object.method)
                : "";
        message.executionBytes =
            object.executionBytes !== undefined && object.executionBytes !== null
                ? bytesFromBase64(object.executionBytes)
                : new Uint8Array();
        message.tokens =
            object.tokens !== undefined && object.tokens !== null
                ? coin_1.Coin.fromJSON(object.tokens)
                : undefined;
        message.relayFee =
            object.relayFee !== undefined && object.relayFee !== null
                ? coin_1.Coin.fromJSON(object.relayFee)
                : undefined;
        message.expiryDuration =
            object.expiryDuration !== undefined && object.expiryDuration !== null
                ? duration_1.Duration.fromJSON(object.expiryDuration)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.connectionId !== undefined &&
            (obj.connectionId = message.connectionId);
        message.executionContract !== undefined &&
            (obj.executionContract = message.executionContract);
        message.method !== undefined && (obj.method = message.method);
        message.executionBytes !== undefined &&
            (obj.executionBytes = base64FromBytes(message.executionBytes !== undefined
                ? message.executionBytes
                : new Uint8Array()));
        message.tokens !== undefined &&
            (obj.tokens = message.tokens ? coin_1.Coin.toJSON(message.tokens) : undefined);
        message.relayFee !== undefined &&
            (obj.relayFee = message.relayFee
                ? coin_1.Coin.toJSON(message.relayFee)
                : undefined);
        message.expiryDuration !== undefined &&
            (obj.expiryDuration = message.expiryDuration
                ? duration_1.Duration.toJSON(message.expiryDuration)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = Object.assign({}, baseMsgExecuteFromCarbon);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.connectionId = (_b = object.connectionId) !== null && _b !== void 0 ? _b : "";
        message.executionContract = (_c = object.executionContract) !== null && _c !== void 0 ? _c : "";
        message.method = (_d = object.method) !== null && _d !== void 0 ? _d : "";
        message.executionBytes = (_e = object.executionBytes) !== null && _e !== void 0 ? _e : new Uint8Array();
        message.tokens =
            object.tokens !== undefined && object.tokens !== null
                ? coin_1.Coin.fromPartial(object.tokens)
                : undefined;
        message.relayFee =
            object.relayFee !== undefined && object.relayFee !== null
                ? coin_1.Coin.fromPartial(object.relayFee)
                : undefined;
        message.expiryDuration =
            object.expiryDuration !== undefined && object.expiryDuration !== null
                ? duration_1.Duration.fromPartial(object.expiryDuration)
                : undefined;
        return message;
    },
};
const baseMsgExecuteFromCarbonResponse = {};
exports.MsgExecuteFromCarbonResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgExecuteFromCarbonResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgExecuteFromCarbonResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgExecuteFromCarbonResponse);
        return message;
    },
};
const baseMsgStartRelay = { relayer: "", nonce: long_1.default.UZERO };
exports.MsgStartRelay = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.relayer !== "") {
            writer.uint32(10).string(message.relayer);
        }
        if (!message.nonce.isZero()) {
            writer.uint32(16).uint64(message.nonce);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgStartRelay);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.relayer = reader.string();
                    break;
                case 2:
                    message.nonce = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgStartRelay);
        message.relayer =
            object.relayer !== undefined && object.relayer !== null
                ? String(object.relayer)
                : "";
        message.nonce =
            object.nonce !== undefined && object.nonce !== null
                ? long_1.default.fromString(object.nonce)
                : long_1.default.UZERO;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.relayer !== undefined && (obj.relayer = message.relayer);
        message.nonce !== undefined &&
            (obj.nonce = (message.nonce || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseMsgStartRelay);
        message.relayer = (_a = object.relayer) !== null && _a !== void 0 ? _a : "";
        message.nonce =
            object.nonce !== undefined && object.nonce !== null
                ? long_1.default.fromValue(object.nonce)
                : long_1.default.UZERO;
        return message;
    },
};
const baseMsgStartRelayResponse = {};
exports.MsgStartRelayResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgStartRelayResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgStartRelayResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgStartRelayResponse);
        return message;
    },
};
const baseMsgPruneExpiredPendingActions = {
    creator: "",
    nonces: long_1.default.UZERO,
};
exports.MsgPruneExpiredPendingActions = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        writer.uint32(18).fork();
        for (const v of message.nonces) {
            writer.uint64(v);
        }
        writer.ldelim();
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgPruneExpiredPendingActions);
        message.nonces = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.nonces.push(reader.uint64());
                        }
                    }
                    else {
                        message.nonces.push(reader.uint64());
                    }
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseMsgPruneExpiredPendingActions);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.nonces = ((_a = object.nonces) !== null && _a !== void 0 ? _a : []).map((e) => long_1.default.fromString(e));
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        if (message.nonces) {
            obj.nonces = message.nonces.map((e) => (e || long_1.default.UZERO).toString());
        }
        else {
            obj.nonces = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseMsgPruneExpiredPendingActions);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.nonces = ((_b = object.nonces) !== null && _b !== void 0 ? _b : []).map((e) => long_1.default.fromValue(e));
        return message;
    },
};
const baseMsgPruneExpiredPendingActionsResponse = {};
exports.MsgPruneExpiredPendingActionsResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgPruneExpiredPendingActionsResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgPruneExpiredPendingActionsResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgPruneExpiredPendingActionsResponse);
        return message;
    },
};
const baseMsgRevertPendingAction = {
    authority: "",
    connectionId: "",
    nonce: long_1.default.UZERO,
    actionType: long_1.default.UZERO,
};
exports.MsgRevertPendingAction = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.authority !== "") {
            writer.uint32(10).string(message.authority);
        }
        if (message.connectionId !== "") {
            writer.uint32(18).string(message.connectionId);
        }
        if (!message.nonce.isZero()) {
            writer.uint32(24).uint64(message.nonce);
        }
        if (!message.actionType.isZero()) {
            writer.uint32(32).uint64(message.actionType);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgRevertPendingAction);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.authority = reader.string();
                    break;
                case 2:
                    message.connectionId = reader.string();
                    break;
                case 3:
                    message.nonce = reader.uint64();
                    break;
                case 4:
                    message.actionType = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgRevertPendingAction);
        message.authority =
            object.authority !== undefined && object.authority !== null
                ? String(object.authority)
                : "";
        message.connectionId =
            object.connectionId !== undefined && object.connectionId !== null
                ? String(object.connectionId)
                : "";
        message.nonce =
            object.nonce !== undefined && object.nonce !== null
                ? long_1.default.fromString(object.nonce)
                : long_1.default.UZERO;
        message.actionType =
            object.actionType !== undefined && object.actionType !== null
                ? long_1.default.fromString(object.actionType)
                : long_1.default.UZERO;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.authority !== undefined && (obj.authority = message.authority);
        message.connectionId !== undefined &&
            (obj.connectionId = message.connectionId);
        message.nonce !== undefined &&
            (obj.nonce = (message.nonce || long_1.default.UZERO).toString());
        message.actionType !== undefined &&
            (obj.actionType = (message.actionType || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseMsgRevertPendingAction);
        message.authority = (_a = object.authority) !== null && _a !== void 0 ? _a : "";
        message.connectionId = (_b = object.connectionId) !== null && _b !== void 0 ? _b : "";
        message.nonce =
            object.nonce !== undefined && object.nonce !== null
                ? long_1.default.fromValue(object.nonce)
                : long_1.default.UZERO;
        message.actionType =
            object.actionType !== undefined && object.actionType !== null
                ? long_1.default.fromValue(object.actionType)
                : long_1.default.UZERO;
        return message;
    },
};
const baseMsgRevertPendingActionResponse = {};
exports.MsgRevertPendingActionResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgRevertPendingActionResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgRevertPendingActionResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgRevertPendingActionResponse);
        return message;
    },
};
const baseMsgConfirmPendingAction = {
    authority: "",
    connectionId: "",
    nonce: long_1.default.UZERO,
    actionType: long_1.default.UZERO,
};
exports.MsgConfirmPendingAction = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.authority !== "") {
            writer.uint32(10).string(message.authority);
        }
        if (message.connectionId !== "") {
            writer.uint32(18).string(message.connectionId);
        }
        if (!message.nonce.isZero()) {
            writer.uint32(24).uint64(message.nonce);
        }
        if (!message.actionType.isZero()) {
            writer.uint32(32).uint64(message.actionType);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgConfirmPendingAction);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.authority = reader.string();
                    break;
                case 2:
                    message.connectionId = reader.string();
                    break;
                case 3:
                    message.nonce = reader.uint64();
                    break;
                case 4:
                    message.actionType = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgConfirmPendingAction);
        message.authority =
            object.authority !== undefined && object.authority !== null
                ? String(object.authority)
                : "";
        message.connectionId =
            object.connectionId !== undefined && object.connectionId !== null
                ? String(object.connectionId)
                : "";
        message.nonce =
            object.nonce !== undefined && object.nonce !== null
                ? long_1.default.fromString(object.nonce)
                : long_1.default.UZERO;
        message.actionType =
            object.actionType !== undefined && object.actionType !== null
                ? long_1.default.fromString(object.actionType)
                : long_1.default.UZERO;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.authority !== undefined && (obj.authority = message.authority);
        message.connectionId !== undefined &&
            (obj.connectionId = message.connectionId);
        message.nonce !== undefined &&
            (obj.nonce = (message.nonce || long_1.default.UZERO).toString());
        message.actionType !== undefined &&
            (obj.actionType = (message.actionType || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseMsgConfirmPendingAction);
        message.authority = (_a = object.authority) !== null && _a !== void 0 ? _a : "";
        message.connectionId = (_b = object.connectionId) !== null && _b !== void 0 ? _b : "";
        message.nonce =
            object.nonce !== undefined && object.nonce !== null
                ? long_1.default.fromValue(object.nonce)
                : long_1.default.UZERO;
        message.actionType =
            object.actionType !== undefined && object.actionType !== null
                ? long_1.default.fromValue(object.actionType)
                : long_1.default.UZERO;
        return message;
    },
};
const baseMsgConfirmPendingActionResponse = {};
exports.MsgConfirmPendingActionResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgConfirmPendingActionResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgConfirmPendingActionResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgConfirmPendingActionResponse);
        return message;
    },
};
const baseMsgAddRelayer = { authority: "", relayer: "" };
exports.MsgAddRelayer = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.authority !== "") {
            writer.uint32(10).string(message.authority);
        }
        if (message.relayer !== "") {
            writer.uint32(18).string(message.relayer);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgAddRelayer);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.authority = reader.string();
                    break;
                case 2:
                    message.relayer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgAddRelayer);
        message.authority =
            object.authority !== undefined && object.authority !== null
                ? String(object.authority)
                : "";
        message.relayer =
            object.relayer !== undefined && object.relayer !== null
                ? String(object.relayer)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.authority !== undefined && (obj.authority = message.authority);
        message.relayer !== undefined && (obj.relayer = message.relayer);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseMsgAddRelayer);
        message.authority = (_a = object.authority) !== null && _a !== void 0 ? _a : "";
        message.relayer = (_b = object.relayer) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
const baseMsgAddRelayerResponse = {};
exports.MsgAddRelayerResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgAddRelayerResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgAddRelayerResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgAddRelayerResponse);
        return message;
    },
};
const baseMsgRemoveRelayer = { authority: "", relayer: "" };
exports.MsgRemoveRelayer = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.authority !== "") {
            writer.uint32(10).string(message.authority);
        }
        if (message.relayer !== "") {
            writer.uint32(18).string(message.relayer);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgRemoveRelayer);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.authority = reader.string();
                    break;
                case 2:
                    message.relayer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgRemoveRelayer);
        message.authority =
            object.authority !== undefined && object.authority !== null
                ? String(object.authority)
                : "";
        message.relayer =
            object.relayer !== undefined && object.relayer !== null
                ? String(object.relayer)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.authority !== undefined && (obj.authority = message.authority);
        message.relayer !== undefined && (obj.relayer = message.relayer);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseMsgRemoveRelayer);
        message.authority = (_a = object.authority) !== null && _a !== void 0 ? _a : "";
        message.relayer = (_b = object.relayer) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
const baseMsgRemoveRelayerResponse = {};
exports.MsgRemoveRelayerResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgRemoveRelayerResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgRemoveRelayerResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgRemoveRelayerResponse);
        return message;
    },
};
class MsgClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.SetBridgeEnabled = this.SetBridgeEnabled.bind(this);
        this.UpdateAxelarIbcChannel = this.UpdateAxelarIbcChannel.bind(this);
        this.UpdateIbcTimeoutHeightOffset =
            this.UpdateIbcTimeoutHeightOffset.bind(this);
        this.UpdateMaxRelayExpiry = this.UpdateMaxRelayExpiry.bind(this);
        this.UpdateRelayWhitelistDuration =
            this.UpdateRelayWhitelistDuration.bind(this);
        this.UpdateRefundAddress = this.UpdateRefundAddress.bind(this);
        this.UpdateParams = this.UpdateParams.bind(this);
        this.CreateConnection = this.CreateConnection.bind(this);
        this.UpdateConnection = this.UpdateConnection.bind(this);
        this.RemoveConnection = this.RemoveConnection.bind(this);
        this.AddControllersForConnection =
            this.AddControllersForConnection.bind(this);
        this.UpdateControllersForConnection =
            this.UpdateControllersForConnection.bind(this);
        this.RemoveControllersForConnection =
            this.RemoveControllersForConnection.bind(this);
        this.RemoveNonceMapForConnection =
            this.RemoveNonceMapForConnection.bind(this);
        this.RegisterExternalToken = this.RegisterExternalToken.bind(this);
        this.DeregisterExternalToken = this.DeregisterExternalToken.bind(this);
        this.DeployNativeToken = this.DeployNativeToken.bind(this);
        this.RegisterDeployedToken = this.RegisterDeployedToken.bind(this);
        this.WithdrawToken = this.WithdrawToken.bind(this);
        this.UpdateExternalToken = this.UpdateExternalToken.bind(this);
        this.DeleteExternalToken = this.DeleteExternalToken.bind(this);
        this.ExecuteFromCarbon = this.ExecuteFromCarbon.bind(this);
        this.StartRelay = this.StartRelay.bind(this);
        this.PruneExpiredPendingActions =
            this.PruneExpiredPendingActions.bind(this);
        this.RevertPendingAction = this.RevertPendingAction.bind(this);
        this.ConfirmPendingAction = this.ConfirmPendingAction.bind(this);
        this.AddRelayer = this.AddRelayer.bind(this);
        this.RemoveRelayer = this.RemoveRelayer.bind(this);
        this.AxelarSendToken = this.AxelarSendToken.bind(this);
        this.AxelarCallContract = this.AxelarCallContract.bind(this);
        this.AxelarCallContractWithToken =
            this.AxelarCallContractWithToken.bind(this);
    }
    SetBridgeEnabled(request) {
        const data = exports.MsgSetBridgeEnabled.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.bridge.Msg", "SetBridgeEnabled", data);
        return promise.then((data) => exports.MsgSetBridgeEnabledResponse.decode(new minimal_1.default.Reader(data)));
    }
    UpdateAxelarIbcChannel(request) {
        const data = exports.MsgUpdateAxelarIbcChannel.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.bridge.Msg", "UpdateAxelarIbcChannel", data);
        return promise.then((data) => exports.MsgUpdateAxelarIbcChannelResponse.decode(new minimal_1.default.Reader(data)));
    }
    UpdateIbcTimeoutHeightOffset(request) {
        const data = exports.MsgUpdateIbcTimeoutHeightOffset.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.bridge.Msg", "UpdateIbcTimeoutHeightOffset", data);
        return promise.then((data) => exports.MsgUpdateIbcTimeoutHeightOffsetResponse.decode(new minimal_1.default.Reader(data)));
    }
    UpdateMaxRelayExpiry(request) {
        const data = exports.MsgUpdateMaxRelayExpiry.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.bridge.Msg", "UpdateMaxRelayExpiry", data);
        return promise.then((data) => exports.MsgUpdateMaxRelayExpiryResponse.decode(new minimal_1.default.Reader(data)));
    }
    UpdateRelayWhitelistDuration(request) {
        const data = exports.MsgUpdateRelayWhitelistDuration.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.bridge.Msg", "UpdateRelayWhitelistDuration", data);
        return promise.then((data) => exports.MsgUpdateRelayWhitelistDurationResponse.decode(new minimal_1.default.Reader(data)));
    }
    UpdateRefundAddress(request) {
        const data = exports.MsgUpdateRefundAddress.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.bridge.Msg", "UpdateRefundAddress", data);
        return promise.then((data) => exports.MsgUpdateRefundAddressResponse.decode(new minimal_1.default.Reader(data)));
    }
    UpdateParams(request) {
        const data = exports.MsgUpdateParams.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.bridge.Msg", "UpdateParams", data);
        return promise.then((data) => exports.MsgUpdateParamsResponse.decode(new minimal_1.default.Reader(data)));
    }
    CreateConnection(request) {
        const data = exports.MsgCreateConnection.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.bridge.Msg", "CreateConnection", data);
        return promise.then((data) => exports.MsgCreateConnectionResponse.decode(new minimal_1.default.Reader(data)));
    }
    UpdateConnection(request) {
        const data = exports.MsgUpdateConnection.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.bridge.Msg", "UpdateConnection", data);
        return promise.then((data) => exports.MsgUpdateConnectionResponse.decode(new minimal_1.default.Reader(data)));
    }
    RemoveConnection(request) {
        const data = exports.MsgRemoveConnection.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.bridge.Msg", "RemoveConnection", data);
        return promise.then((data) => exports.MsgRemoveConnectionResponse.decode(new minimal_1.default.Reader(data)));
    }
    AddControllersForConnection(request) {
        const data = exports.MsgAddControllersForConnection.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.bridge.Msg", "AddControllersForConnection", data);
        return promise.then((data) => exports.MsgAddControllersForConnectionResponse.decode(new minimal_1.default.Reader(data)));
    }
    UpdateControllersForConnection(request) {
        const data = exports.MsgUpdateControllersForConnection.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.bridge.Msg", "UpdateControllersForConnection", data);
        return promise.then((data) => exports.MsgUpdateControllersForConnectionResponse.decode(new minimal_1.default.Reader(data)));
    }
    RemoveControllersForConnection(request) {
        const data = exports.MsgRemoveControllersForConnection.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.bridge.Msg", "RemoveControllersForConnection", data);
        return promise.then((data) => exports.MsgRemoveControllersForConnectionResponse.decode(new minimal_1.default.Reader(data)));
    }
    RemoveNonceMapForConnection(request) {
        const data = exports.MsgRemoveNonceMapForConnection.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.bridge.Msg", "RemoveNonceMapForConnection", data);
        return promise.then((data) => exports.MsgRemoveNonceMapForConnectionResponse.decode(new minimal_1.default.Reader(data)));
    }
    RegisterExternalToken(request) {
        const data = exports.MsgRegisterExternalToken.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.bridge.Msg", "RegisterExternalToken", data);
        return promise.then((data) => exports.MsgRegisterExternalTokenResponse.decode(new minimal_1.default.Reader(data)));
    }
    DeregisterExternalToken(request) {
        const data = exports.MsgDeregisterExternalToken.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.bridge.Msg", "DeregisterExternalToken", data);
        return promise.then((data) => exports.MsgDeregisterExternalTokenResponse.decode(new minimal_1.default.Reader(data)));
    }
    DeployNativeToken(request) {
        const data = exports.MsgDeployNativeToken.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.bridge.Msg", "DeployNativeToken", data);
        return promise.then((data) => exports.MsgDeployNativeTokenResponse.decode(new minimal_1.default.Reader(data)));
    }
    RegisterDeployedToken(request) {
        const data = exports.MsgRegisterDeployedToken.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.bridge.Msg", "RegisterDeployedToken", data);
        return promise.then((data) => exports.MsgRegisterDeployedTokenResponse.decode(new minimal_1.default.Reader(data)));
    }
    WithdrawToken(request) {
        const data = exports.MsgWithdrawToken.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.bridge.Msg", "WithdrawToken", data);
        return promise.then((data) => exports.MsgWithdrawTokenResponse.decode(new minimal_1.default.Reader(data)));
    }
    UpdateExternalToken(request) {
        const data = exports.MsgUpdateExternalToken.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.bridge.Msg", "UpdateExternalToken", data);
        return promise.then((data) => exports.MsgUpdateExternalTokenResponse.decode(new minimal_1.default.Reader(data)));
    }
    DeleteExternalToken(request) {
        const data = exports.MsgDeleteExternalToken.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.bridge.Msg", "DeleteExternalToken", data);
        return promise.then((data) => exports.MsgDeleteExternalTokenResponse.decode(new minimal_1.default.Reader(data)));
    }
    ExecuteFromCarbon(request) {
        const data = exports.MsgExecuteFromCarbon.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.bridge.Msg", "ExecuteFromCarbon", data);
        return promise.then((data) => exports.MsgExecuteFromCarbonResponse.decode(new minimal_1.default.Reader(data)));
    }
    StartRelay(request) {
        const data = exports.MsgStartRelay.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.bridge.Msg", "StartRelay", data);
        return promise.then((data) => exports.MsgStartRelayResponse.decode(new minimal_1.default.Reader(data)));
    }
    PruneExpiredPendingActions(request) {
        const data = exports.MsgPruneExpiredPendingActions.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.bridge.Msg", "PruneExpiredPendingActions", data);
        return promise.then((data) => exports.MsgPruneExpiredPendingActionsResponse.decode(new minimal_1.default.Reader(data)));
    }
    RevertPendingAction(request) {
        const data = exports.MsgRevertPendingAction.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.bridge.Msg", "RevertPendingAction", data);
        return promise.then((data) => exports.MsgRevertPendingActionResponse.decode(new minimal_1.default.Reader(data)));
    }
    ConfirmPendingAction(request) {
        const data = exports.MsgConfirmPendingAction.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.bridge.Msg", "ConfirmPendingAction", data);
        return promise.then((data) => exports.MsgConfirmPendingActionResponse.decode(new minimal_1.default.Reader(data)));
    }
    AddRelayer(request) {
        const data = exports.MsgAddRelayer.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.bridge.Msg", "AddRelayer", data);
        return promise.then((data) => exports.MsgAddRelayerResponse.decode(new minimal_1.default.Reader(data)));
    }
    RemoveRelayer(request) {
        const data = exports.MsgRemoveRelayer.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.bridge.Msg", "RemoveRelayer", data);
        return promise.then((data) => exports.MsgRemoveRelayerResponse.decode(new minimal_1.default.Reader(data)));
    }
    AxelarSendToken(request) {
        const data = exports.MsgAxelarSendToken.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.bridge.Msg", "AxelarSendToken", data);
        return promise.then((data) => exports.MsgAxelarSendTokenResponse.decode(new minimal_1.default.Reader(data)));
    }
    AxelarCallContract(request) {
        const data = exports.MsgAxelarCallContract.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.bridge.Msg", "AxelarCallContract", data);
        return promise.then((data) => exports.MsgAxelarCallContractResponse.decode(new minimal_1.default.Reader(data)));
    }
    AxelarCallContractWithToken(request) {
        const data = exports.MsgAxelarCallContractWithToken.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.bridge.Msg", "AxelarCallContractWithToken", data);
        return promise.then((data) => exports.MsgAxelarCallContractWithTokenResponse.decode(new minimal_1.default.Reader(data)));
    }
}
exports.MsgClientImpl = MsgClientImpl;
var globalThis = (() => {
    if (typeof globalThis !== "undefined")
        return globalThis;
    if (typeof self !== "undefined")
        return self;
    if (typeof window !== "undefined")
        return window;
    if (typeof global !== "undefined")
        return global;
    throw "Unable to locate global object";
})();
const atob = globalThis.atob ||
    ((b64) => globalThis.Buffer.from(b64, "base64").toString("binary"));
function bytesFromBase64(b64) {
    const bin = atob(b64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; ++i) {
        arr[i] = bin.charCodeAt(i);
    }
    return arr;
}
const btoa = globalThis.btoa ||
    ((bin) => globalThis.Buffer.from(bin, "binary").toString("base64"));
function base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr) {
        bin.push(String.fromCharCode(byte));
    }
    return btoa(bin.join(""));
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
